module.exports = __webpack_public_path__ + "static/media/ico-share.04c57360.svg";